'use strict';

module.exports = {
  PAYPAL: 'PAYPAL',
  COINBASE: 'COINBASE',
  STRIPE: 'STRIPE'
};
